//#region ../schema-sql-parser/dist/parser/dataType/Oracle.js
var OracleTypes = [
	"ANYDATA",
	"BFILE",
	"BINARY_DOUBLE",
	"BINARY_FLOAT",
	"BLOB",
	"BOOL",
	"BOOLEAN",
	"CHAR VARYING",
	"CHAR",
	"CHARACTER VARYING",
	"CHARACTER",
	"CLOB",
	"DATE",
	"DEC",
	"DECIMAL",
	"DOUBLE PRECISION",
	"FLOAT",
	"INT",
	"INTEGER",
	"INTERVAL DAY TO SECOND",
	"INTERVAL YEAR TO MONTH",
	"JSON",
	"LONG RAW",
	"LONG VARCHAR",
	"LONG",
	"NATIONAL CHAR VARYING",
	"NATIONAL CHAR",
	"NATIONAL CHARACTER VARYING",
	"NATIONAL CHARACTER",
	"NCHAR VARYING",
	"NCHAR",
	"NCLOB",
	"NUMBER",
	"NUMERIC",
	"NVARCHAR2",
	"RAW",
	"REAL",
	"ROWID",
	"SDO_GEOMETRY",
	"SDO_GEORASTER",
	"SDO_TOPO_GEOMETRY",
	"SMALLINT",
	"TIMESTAMP WITH LOCAL TIME ZONE",
	"TIMESTAMP WITH TIME ZONE",
	"TIMESTAMP",
	"URIType",
	"UROWID",
	"VARCHAR",
	"VARCHAR2",
	"VECTOR",
	"XMLType"
];
//#endregion
export { OracleTypes };
